<template>
  <div class="expiry-top-container left" @click="focusMonth($event)" :class="{'focus-input': focussed}">
    <label class="field-title" :class="{'on': true}">
      {{expiryLabel}}
    </label>
    <div class="expiry-container">
      <input ref="monthElement" id="cb-month" maxlength='2' class="month" :class="{'with-value' : month}" type="text" placeholder="MM" v-model="month" @blur="blur($event)" @focus="focus($event)" @input="triggerInput($event)" @keypress="checkForNumber"/>
      /
      <input ref="yearElement" maxlength='2' class="year" :class="{'with-value' : year}" type="text" placeholder="YY" v-model="year" @blur="blur($event)" @focus="focus($event)" @input="triggerInput($event)" @keyup.delete="previous($event)" @keypress="checkForNumber"/>
    </div>
    <p class="error-msg" v-if="!!errorMessage && !focussed">
      {{errorMessage}}
    </p>
  </div>
</template>
<script type="text/javascript">
  import Validators from "./../helpers/validators.js";
  export default {
    computed: {
      focussed() {
        return this.focussed1 || this.focussed2
      },
      expiryLabel() {
        return this.config.filter(({name}) => (name == "card.expiry"))[0].label;
      },
      monthConfig() {
        return this.config.filter(({name}) => (name == "card[expiry_month]"))[0];
      },
      yearConfig() {
        return this.config.filter(({name}) => (name == "card[expiry_year]"))[0];
      }
    },
    data() {
      return {
        focussed1: false,
        focussed2: false,
        errorMessage: "",
        invalid: false,
        month: "",
        year: ""
      }
    },
    props: ['config', 'data'],
    methods: {
      triggerInput(event) {
        if(event.target == this.$refs.monthElement) {
          if(this.month.length == 2) {
            this.validate(this.monthConfig, this.$refs.monthElement);
            if(!this.invalid) {
              this.$refs.yearElement.focus();
            }
          }
        }
        if(event.target == this.$refs.yearElement) {
          if(this.year.length == 2) {
            this.validate(this.yearConfig, this.$refs.yearElement);
          }
        }
        this.$emit('input', this.month, this.year);
      },

      validate(config, element) {
        var validations = config.validations;
        if(validations) {
          Object.keys(validations).some(key => {
            this.errorMessage = Validators[key] && Validators[key](element, validations[key]);
            return !!this.errorMessage;
          });
        }
        this.invalid = !!this.errorMessage;
      },

      blur(event) {
        if(event.target == this.$refs.monthElement) {
          this.focussed1 = false;
        }
        if(event.target == this.$refs.yearElement) {
          this.focussed2 = false;
        }
      },

      focus(event) {
        if(event.target == this.$refs.monthElement) {
          this.focussed1 = true;
        }
        if(event.target == this.$refs.yearElement) {
          this.focussed2 = true;
        }
        this.errorMessage = "";
        this.invalid = false;
      },

      previous(event) {
        if(event.keyCode == 8 && this.year.length == 0) {
          this.$refs.monthElement.focus();
        }
      },

      focusMonth(event) {
        if(!this.focussed) {
          this.$refs.monthElement.focus();
        }
      },

      checkForNumber(event) {
        var digit = String.fromCharCode(event.which)
        if(!/^\d+$/.test(digit)){
          event.preventDefault();
        }
      }
    },

    mounted() {
      this.$refs.yearElement.dataset['monthElementId'] = this.$refs.monthElement.id;
    }
  }

</script>

<style scoped>
  input.month, input.year {
    display: inline-block;
    max-width: 32px;
    width: auto;
    padding-right: 0px;
    padding-left: 0px;
    letter-spacing: 1px;
  }
  input.month {
    margin-left: 2px;
  }

  input.month.with-value, input.year.with-value {
    max-width: 20px;
  }

  .expiry-container {
    padding-left: 10px;
  }

  .expiry-top-container {
    /*border: 1px solid #B4B4BE;*/
  }

  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #AFB2B7;
    font-weight: 300;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #AFB2B7;
    font-weight: 300;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #AFB2B7;
    font-weight: 300;
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #AFB2B7;
    font-weight: 300;
  }
</style>


// WEBPACK FOOTER //
// ExpiryComponent.vue?a998b858